<template>
  <div>
    <div class="search-top-row">
      <el-row>
        <el-col style="text-align:center">
          <el-select
            v-model="queryParams.isActive"
            size="small"
            placeholder="过期状态"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in activeList"
              :key="idx"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
          <el-select
            v-model="queryParams.publishStatus"
            size="small"
            placeholder="禁用状态"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in statusList"
              :key="idx"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
          <el-select
            v-if="employeeLevel === 50"
            v-model="queryParams.orgCode"
            size="small"
            placeholder="选择区域"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in orgList"
              :key="idx"
              :value="item.orgCode"
              :label="item.orgName"
            />
          </el-select>
          <el-select
            v-model="queryParams.channelCode"
            size="small"
            placeholder="选择渠道"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in channelList"
              :key="idx"
              :value="item.key"
              :label="item.value"
            />
          </el-select>
          <!-- <el-select v-model="queryParams.themeCode" size="small" placeholder="选择主题" clearable filterable>
            <el-option v-for="(item, idx) in themeDefineList" :key="idx" :value="item.themeCode" :label="item.themeName"/>
          </el-select> -->
          <el-input
            class="search-input"
            v-model="queryParams.themeName"
            placeholder="主题名称"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search noselect"
            ></i>
          </el-input>
          <el-button class="btn-red" size="small" @click="getThemeList()"
            >搜索</el-button
          >
          <div class="history-config">
            <el-button class="btn-reset" size="small" @click="resetSearch()"
              >重置</el-button
            >
            <div style="padding-top:20px">
              <el-button class="btn-red" @click="viewConfigHistory()">历史配置</el-button>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>

    <!-- 横向数据列表 -->
    <div class="menu-row" v-loading="loading" v-if="themeDefineList.length">
      <div
        class="menu-row-left noselect"
        @click="moveCarousel(-1)"
        :disabled="atHeadOfList"
      ></div>
      <div class="menu-card-carousel">
        <div class="card-carousel--overflow-container">
          <div
            class="card-carousel-cards"
            :style="{
              transform: 'translateX' + '(' + currentOffset + 'px' + ')'
            }"
          >
            <div
              class="card-carousel-cards-item"
              v-for="(item, index) in themeDefineList"
              :key="index"
            >
              <div class="card-theme theme">
                <div class="theme-name">{{ item.themeName }}</div>
                <div class="theme-channel">{{ item.channelName }}</div>
              </div>
              <div class="card-status status">
                <div class="no-config">
                  未配置：
                  <span class="status-num">{{
                    item.unfinishedConfiguredQty
                  }}</span>
                </div>
                <div class="has-config">
                  已配置：
                  <span class="status-num">{{
                    item.alreadyConfiguredQty
                  }}</span>
                </div>
              </div>
              <div class="time-range status">
                {{ item.startDate | parseDate }} -
                {{ item.endDate | parseDate }}
              </div>
              <div
                class="create-btn noselect"
                :class="{ hasCreate: item.unfinishedConfiguredQty <= 0 }"
                @click="jumpConfig('config', item)"
              >
                <div class="create-img"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="menu-row-right noselect"
        @click="moveCarousel(1)"
        :disabled="atEndOfList"
      ></div>
    </div>

    <div class="theme-bottom" v-loading="loading">
      <!-- 列表详情 -->
      <div
        class="theme-list-item"
        v-for="(item, index) in themeList"
        :key="index"
      >
        <PerfectThemeListItem :info="item"></PerfectThemeListItem>
      </div>
      <div class="no-data" v-if="themeList.length === 0">暂无数据</div>

      <!-- 翻页 -->
      <el-row v-if="themeList.length != 0" class="footer-pagination">
        <el-col>
          <el-pagination
            background
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import PerfectThemeListItem from './components/perfect-theme-list-item'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  components: {
    PerfectThemeListItem
  },
  data () {
    return {
      loading: false,
      currentOffset: 0,
      paginationFactor: 260,
      windowSize: 3,
      themeDefineList: [],
      themeList: [],
      orgList: [], // 区域
      page: 1,
      pageSize: 10,
      total: null,
      employeeLevel: '',
      queryParams: {
        // themeCode: '',
        channelCode: '',
        publishStatus: '',
        orgCode: '',
        isActive: '',
        themeName: ''
      },
      activeList: [
        { id: '0', name: '已过期' },
        { id: '1', name: '生效中' }
      ],
      statusList: [
        { id: '0', name: '已禁用' },
        { id: '1', name: '已启用' }
      ]
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      channelList: state => state.base.tradeStackThemeChannelMap
    }),
    // 横向移动右边限制
    atEndOfList () {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.themeDefineList.length - this.windowSize)
      )
    },
    // 横向移动左边限制
    atHeadOfList () {
      return this.currentOffset === 0
    }
  },

  mounted () {
    this.getOrgList()
    this.getParentThemeList()
    // this.getThemeList()
  },

  created () {
    this.$store.dispatch('getDictByName', 'tradeStackThemeChannelMap')
    this.employeeLevel = this.userInfo.employeeLevel
    if (localStorageUtils.get('stackPerfectQueryParams')) {
      this.queryParams = JSON.parse(
        localStorageUtils.get('stackPerfectQueryParams')
      )
      this.queryParams.page = 1
    }
    this.getThemeList()
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'perfect-theme-config') {
      localStorageUtils.set(
        'stackPerfectQueryParams',
        JSON.stringify(this.queryParams)
      )
    } else {
      localStorageUtils.remove('stackPerfectQueryParams')
    }
    next()
  },

  methods: {
    // 获取横向的列表
    getParentThemeList () {
      this.loading = true
      this.$store
        .dispatch('getPerfectParentThemeList')
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.themeDefineList =
              res.data.resultData.parentThemeDefineList || []
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 获取列表
    getThemeList () {
      this.loading = true
      let params = _.assign(this.queryParams, {
        page: this.page,
        pageSize: 10
      })
      this.$store
        .dispatch('getPerfectThemeList', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.themeList =
              res.data.resultData.tradePerfectThemeDefineList || []
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 重置
    resetSearch () {
      this.queryParams = this.$options.data().queryParams
      this.getThemeList()
    },

    // 页面跳转
    jumpConfig (type, item) {
      // 限制
      if (type === 'config' && item.unfinishedConfiguredQty <= 0) return

      let query
      // 新增时 传该数据对应的源数据id
      if (type === 'config') {
        query = {
          handleType: type,
          themeDefineId: item.themeDefineId,
          publishStatus: item.publishStatus
        }
        this.$router.push({
          path: '/trade/perfect-theme-config',
          query: query
        })
      }

      // 修改时 传该数据id
      if (type === 'update') {
        query = {
          handleType: type,
          themeDefineId: item.themeDefineId
        }
        this.$router.push({
          path: '/trade/perfect-theme-config',
          query: query
        })
      }
    },

    // 横向列表移动
    moveCarousel (direction) {
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor
      }
    },

    // 获取区域
    getOrgList () {
      this.$store
        .dispatch('areaList')
        .then(res => {
          if (res.data.resultCode === '0') {
            if (this.employeeLevel === 50) {
              this.orgList = res.data.resultData.regionList || []
            }
            if (this.employeeLevel === 60) {
              this.orgList = res.data.resultData.buList || []
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.getThemeList()
    },

    // 查看历史配置
    viewConfigHistory () {
      console.log('viewConfigHistory')
      let routeData = this.$router.resolve({
        name: 'perfect-history-list'
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-reset {
  background-color: #7f7f7f;
  color: #ffffff;
}
.history-config {
  display: inline-block;
  padding-left: 10px;
  vertical-align: top;
  text-align: left;
  div {
    text-align: left;
    padding-top: 10px;
    margin-left: -40px;
  }
}
.menu-row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 870px;
  height: 240px;
  margin: 10px auto 40px;
  color: #666a73;
  .menu-card-carousel {
    display: flex;
    justify-content: center;
    width: 780px;
  }
  .card-carousel--overflow-container {
    overflow: hidden;
  }

  .card-carousel-cards {
    display: flex;
    transition: transform 0.25s ease-out;
    transform: translatex(0px);
    height: 180px;
    text-align: center;
    box-sizing: border-box;
  }
  .card-carousel-cards-item {
    position: relative;
    margin: 0 20px;
    background-color: #fff;
    border-radius: 4px;
    z-index: 3;
    margin-bottom: 2px;
    flex-shrink: 0;
    width: 220px;
    border-radius: 15px;
    .card-theme,
    .card-status {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
    }
    .status-num {
      color: $base-red;
    }
    .theme {
      margin: 15px 15px;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
    }
    .status {
      margin: 15px 35px;
    }
    .time-range {
      font-size: 12px;
      margin: 15px;
    }
    .create-btn {
      position: absolute;
      width: 100%;
      height: 34px;
      bottom: 0;
      background-color: $base-red;
      border-bottom-right-radius: 15px;
      border-bottom-left-radius: 15px;
      cursor: pointer;
    }
    .create-img {
      width: 24px;
      height: 24px;
      margin: 5px auto 5px;
      background: url("../../assets/images/create.png") no-repeat;
    }
    .hasCreate {
      background-color: #c0c0c0;
    }
    .theme-name {
      width: 50%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .theme-channel {
      width: 50%;
    }
  }
  .menu-row-left,
  .menu-row-right {
    display: inline-block;
    width: 20px;
    height: 20px;
    padding: 8px;
    box-sizing: border-box;
    border-top: 4px solid $base-red;
    border-right: 4px solid $base-red;
    cursor: pointer;
    margin: 0 10px;
    transition: transform 0.2s linear;
  }
  .menu-row-left[disabled],
  .menu-row-right[disabled] {
    opacity: 0.2;
    border-color: black;
    cursor: not-allowed;
  }
  .menu-row-left {
    transform: rotate(-135deg);
  }
  .menu-row-left:active {
    transform: rotate(-135deg) scale(0.85);
  }
  .menu-row-right {
    transform: rotate(45deg);
  }
  .menu-row-right:active {
    transform: rotate(45deg) scale(0.85);
  }
}
.theme-bottom {
  width: 870px;
  margin: 0 auto;
}
.theme-list-item {
  height: 100px;
  margin: 0 auto 20px;
  padding: 0 10px;
  box-sizing: border-box;
}
.no-data {
  text-align: center;
}

.search-input.el-input {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.search-input {
  .el-input__icon {
    line-height: 32px;
  }
  ::v-deep .el-input__inner {
    height: 32px;
    border-radius: 5px;
  }
}

.el-select {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
}
.footer-pagination {
  width: 720px;
  text-align: center;
  margin: 40px 0px 0px;
  height: 48px;
}
</style>
